import React from "react"
import styles from "./GroupGameTable.module.css";
import GroupGameTableRow from "./GroupGameTableRow";
import Chakra3_transparent from "../../image/Chakra3_transparent.png";
import {group_game_coordinates, calculatePlayerPosShift} from "../player_coordinates_calculator";
import ArrowsMap from "../ArrowsMap";

export default function GroupGameTable(props) {
    function PlayerStyle(players, currentPlayer, selectedPlayerId, playersPositions, selectedPlayerChange) {
        if (!playersPositions) {
            return Object.assign({})
        }
        // const currentPlayerPos = currentPlayer.current_user_position
        const currentPlayerPos = playersPositions[currentPlayer.id]

        const cellHeight = parseInt(props.fieldStyle.cell_height)
        const cellWidth = parseInt(props.fieldStyle.cell_width)
        const tablePaddingTop = parseInt(props.fieldStyle.padding_top)
        const tablePaddingleft = parseInt(props.fieldStyle.padding_left)

        const coords = group_game_coordinates(currentPlayerPos, cellWidth, cellHeight, tablePaddingTop, tablePaddingleft)

        const playersIdsList = players.map(player => player.id)
        const playerShift = calculatePlayerPosShift(playersIdsList, playersPositions, currentPlayer.id)
        const groupGameShift = 50
        const opacity = currentPlayer.id === selectedPlayerId ? "1" : "0.7"
        const scale = currentPlayer.id === selectedPlayerId ? "1.35" : "1"
        const zIndex = currentPlayer.id === selectedPlayerId ? "1002" : "1001"
        const fontColor = currentPlayer.id === selectedPlayerId ? "red" : "black"
        const fontWeight = currentPlayer.id === selectedPlayerId ? "bold" : "unset"
        const transition = selectedPlayerChange ? "all 0.2s linear" : "all 2s linear"

        return Object.assign(
            {
                display: "flex",
                backgroundImage: "url(" + Chakra3_transparent +")",
                backgroundColor: currentPlayer.chip_color,
                borderRadius: "20px",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundAttachment: "local",
                backgroundPosition: "center",
                height: "40px",
                width: "40px",
                position: "absolute",
                transition: transition,
                top: coords.top + playerShift.top + groupGameShift,
                left: coords.left + playerShift.left,
                textAlign: "center",
                alignContent: "center",
                fontWeight: fontWeight,
                fontSize: "1em",
                opacity: opacity,
                color: fontColor,
                cursor: props.gameState.role === "mentor" ? "pointer" : "default",
                scale: scale,
                zIndex:zIndex,
            }

        )
    }

    function getSelectedPlayerData(playerId) {
        for (const player of props.gameState.players) {
            if (player.id === playerId) {
                return player
            }
        }
    }

    return (
        <>  {props.gameState.players.map((player) => {
            return <div
                key={player.id}
                id={player.id}
                style={new PlayerStyle(props.gameState.players, player, props.selectedPlayer, props.playersPositions, props.selectedPlayerChange)}
                onClick={() => {
                    if (props.gameState.role === "mentor") {
                        props.setSelectedPlayer(player.id)
                    }
                }}
            >
                <div className={props.gameState.role === "mentor" ? styles.chipCharMentorView : styles.chipChar}>{player.chip_char}</div>
            </div>
        })}
            <ArrowsMap
                fieldStyle={props.fieldStyle}
                steps={getSelectedPlayerData(props.selectedPlayer).steps}
                gameFieldOffset={50}
            />
            <table className={styles.mainTable}>
                <tbody style={{border: props.fieldStyle.table_border}}>
                {props.cellsData.map((item) => {
                    return <GroupGameTableRow
                        key={item.row_id}
                        row_data={item.items}
                        cards={props?.cards}
                        fieldStyle={props.fieldStyle}
                        gameState={props.gameState}
                        selectedPlayerId={props.selectedPlayer}
                    />
                })}
                </tbody>
            </table>
        </>
    );

}